import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'react-tooltip-lite';
import OutsideClickHandler from 'react-outside-click-handler';

// Handle tooltip state here
// to-do: add outsideclickhandler

class TooltipWrapper extends PureComponent {

  // static getDerivedStateFromProps(nextProps, nextState) {

  //   if (nextProps.isOpen !== nextState.isVisible) {
  //     return { isVisible: nextProps.isOpen };
  //   }

  //   return null;
  // }

  constructor(props) {
    super(props);

    this.tipContentRef = React.createRef();
    this.buttonRef = React.createRef();
  }

  state = {
    isVisible: this.props.isVisible || false,
    openOnMount: false,
  }

  /* eslint-disable camelcase */
  UNSAFE_componentWillReceiveProps(nextProps, nextState) {
    if (nextProps.isOpen !== nextState.isVisible) {
      this.setState({ isVisible: nextProps.isOpen });
    }

    if (nextProps.openOnMount !== this.props.openOnMount) {
      this.setState({ isVisible: nextProps.openOnMount });
    }
  }
  /* eslint-enable camelcase */

  handleClick = (e) => {
    e.preventDefault();

    this.setState(prevState => {

      const isVisible = !prevState.isVisible;

      this.props.onChange({ isVisible });

      return { isVisible };
    });
  }

  bodyClick = (e) => {

    const isVisible = false;

    if(this.tipContentRef.current && (
      this.tipContentRef.current.contains(e.target) ||
      this.buttonRef.current.contains(e.target)
    )) {
      return;
    }

    if(isVisible !== this.state.isVisible) {
      this.props.onChange({ isVisible });
      this.setState({ isVisible });
    }
  }

  render() {

    const { isVisible } = this.state;
    const { onOpenTargetJSX, contentClass = '', useHover = false } = this.props;

    const closeButton = this.props.withCloseButton && (
      <span className="pointer tooltip-close-button" onClick={this.handleClick}>
        <i className="icon-close-simple" />
      </span>
    );

    const newContent = (
      <div ref={this.tipContentRef} className={contentClass ? contentClass : 'd-inline-block'}>
        {closeButton}
        {this.props.content}
      </div>
    );

    const newTarget = (
      <span ref={this.buttonRef} onClick={(e) => this.handleClick(e)}>
        <a className="toggle-button">
          {isVisible ? (onOpenTargetJSX || this.props.children) : this.props.children}
        </a>
      </span>
    );

    return ( !useHover ?
      <OutsideClickHandler display="inline" onOutsideClick={this.bodyClick}>
        <Tooltip
          {...this.props}
          content={newContent}
          isOpen={isVisible}
        >
          {newTarget}
        </Tooltip>
      </OutsideClickHandler>
      :
      <Tooltip
        {...this.props}
        eventToggle={''}
        content={newContent}
        useHover
      >
        {newTarget}
      </Tooltip>
    );
  }
}

TooltipWrapper.defaultProps = {
  content: '',
  direction: 'up-center',
  padding: '25px',
  tagName: 'span',
  className: 'tooltip-target',
  tipContentHover: true,
  eventToggle: 'onClick',
  useHover: false,
  getVisibleState: () => { },
  onChange() {},
};

TooltipWrapper.propTypes = {
  content: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
  direction: PropTypes.string,
  tagName: PropTypes.string,
  className: PropTypes.string,
  tipContentHover: PropTypes.bool,
  eventToggle: PropTypes.string,
  useHover: PropTypes.bool,
  getVisibleState: PropTypes.func,
  onChange: PropTypes.func,
};

export default TooltipWrapper;



// WEBPACK FOOTER //
// ./js/components/global/TooltipWrapper.js